import { defineReference } from './definition';

defineReference({
  WebGL2RenderingContext: {
    cf: ['WebGLRenderingContext'],
  },
});
